import React from 'react';
import { createRoot } from 'react-dom/client';
import AdvocacyQuizApp  from './components/advocacy-quiz-app'

const advocacyQuiz = document.getElementById('advocacy-quiz-app');

if (advocacyQuiz) {
    const root = createRoot(advocacyQuiz);

    const { questions, contentId} = (window as any).bootstrap;

    root.render(
        <AdvocacyQuizApp
            questions={questions}
            contentId={contentId} />
    );
}